import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";
const OrganicIntermediatesAromaticity = () => (
  <QPhototModuleSubtopic
    title="Organic intermediates and aromaticity"
    videos={[
      "https://www.youtube.com/embed/5BSQG2sbrQw",
      "https://www.youtube.com/embed/B2Ntf951Ztg",
      "https://www.youtube.com/embed/2pSP1DJ-djE",
      "https://www.youtube.com/embed/ab4WFo0Eq-k",
      "https://www.youtube.com/embed/6b2gZA70xxg"
    ]}
    takeaways={[
      { text: "Learn Carbocation and carbanion stability order." },
      { text: "Huckle's Rule related question can expect." },
      { text: "Learn all the exceptions related to aromaticity." }
    ]}
    questions={[
        {
            image:"/ch_3.jpeg"
        },
        {
            image:"/ch_4.jpeg"
        },
        {
            image:"/ch_5.jpeg"
        },
        {
            text:"Explain the criteria for any compound to be (i) Aromatic, (ii)Non-Aromatic, and (iii)Anti aromatic with appropriate examples. Explain in detail the aromaticity of pyrrole and protonated pyrrole. "
        },
        {
            text:"a)Explain the stability of carbanions based on inductive and resonance effects with suitable examples. B)What are the factors that stabilize tertiary and benzyl free radical? "
        }
      
    ]}
    exampleVideos={[]}
  />
);

export default OrganicIntermediatesAromaticity;
